import Checkbox from '@mui/material/Checkbox'
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle'
import {Link} from 'react-router-dom'
import {trucktypes} from 'constants/trucktypes'

export default function DailyEventCard({
                                           event,
                                           checked,
                                           handleToggle,
                                           labelId
                                       }: {
    event: any
    checked: any[]
    handleToggle: (value: string) => () => void
    labelId: string
}) {
    const {
        name,
        truckAssignments,
        backgroundColor,
        borderColor,
        textColor,
        status,
        orderNumber
    } = event
    const totalCalculatedTime = truckAssignments.reduce(
        (acc: number, assignment: any) => {
            return acc + assignment.calculated_time
        },
        0
    )
    const totalsTruckTypes = truckAssignments.reduce(
        (acc: any, assignment: any) => {
            const truckType = assignment.class.truck_type

            if (truckType === 0 || truckType === 1) {
                acc[truckType] += 1
            }

            return acc
        },
        {0: 0, 1: 0}
    )
    const truckAssignmentsLength = truckAssignments.length
    const isMultipleTrucks = truckAssignmentsLength > 1

    return (
        <div
            className="rounded-xl p-4 flex gap-1 items-start"
            style={{backgroundColor, borderColor, color: textColor}}
        >
            <Checkbox
                edge="start"
                checked={checked.includes(event.id)}
                tabIndex={-1}
                disableRipple
                onClick={handleToggle(event.id)}
                inputProps={{'aria-labelledby': labelId}}
            />
            <Link className="w-full" to={`/admin/orders/${event.orderId}`}>
                <div className="flex flex-col gap-4 font-semibold text-sm w-full relative">
                    <div className="leading-tight">
                        <h5>#{orderNumber}</h5>
                        <p
                            className="text-xs"
                            style={{color: status === 'completed' ? '#81B57F' : '#7F96B5'}}
                        >
                            {name}
                        </p>
                    </div>
                    <div className="flex justify-between">
            <span>
              {totalCalculatedTime} minutes / {truckAssignmentsLength} Item
                {truckAssignmentsLength > 1 ? 's' : ''}
            </span>
                        <span>
              {isMultipleTrucks ? (
                  <>
                      Box: {totalsTruckTypes[1]} - Dump: {totalsTruckTypes[0]}
                  </>
              ) : (
                  <>{trucktypes[truckAssignments[0].class.truck_type as 0 | 1]}</>
              )}
            </span>
                    </div>
                    {isMultipleTrucks ? (
                        <span className="absolute right-0 top-0 flex flex-col">
              <AirportShuttleIcon/>
              <AirportShuttleIcon/>
            </span>
                    ) : null}
                </div>
            </Link>
        </div>
    )
}
